import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';

import {BuilderV2RoutingModule} from './builder-v2-routing.module';
import {BuilderV2Component} from "./builder-v2.component";
import {BuilderHeaderComponent} from "./components/builder-header/builder-header.component";
import {DsTooltipDirective} from "../shared/directives/ds-tooltip/ds-tooltip.directive";
import {BuilderCanvasComponent} from './components/builder-canvas/builder-canvas.component';
import {
  PageConstructorComponent
} from './components/builder-canvas/components/page-constructor/page-constructor.component';
import {ZoomControllerComponent} from './components/zoom-controller/zoom-controller.component';
import {DragulaModule} from "ng2-dragula";
import {WebsiteCustomizerComponent} from './components/website-customizer/website-customizer.component';
import {DbTextPipe} from "../shared/pipes/db-text.pipe";
import {NgxIntlTelInputModule} from "ngx-intl-tel-input-gg";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {
  WebsiteCustomizerSwitcherComponent
} from './components/website-customizer/components/website-customizer-switcher/website-customizer-switcher.component';
import {
  WebsiteCustomizerSwitcherTooltipComponent
} from './components/website-customizer/components/website-customizer-switcher-tooltip/website-customizer-switcher-tooltip.component';
import {
  OutlineGenerationComponent
} from './components/outline-generation/outline-generation.component';
import {
  OutlineGenerationTourBannerComponent
} from './components/outline-generation-tour-banner/outline-generation-tour-banner.component';
import {ClickOutsideDirective} from "../shared/directives/click-outside/click-outside.directive";
import {PageSectionComponent} from './components/builder-canvas/components/page-section/page-section.component';
import {ClassChangeObserverDirective} from "../shared/directives/class-change-observer/class-change-observer.directive";
import {ZoomTooltipComponent} from './components/zoom-controller/components/zoom-tooltip/zoom-tooltip.component';
import {TooltipOptionComponent} from './components/tooltip-option/tooltip-option.component';
import {
  SectionActionTooltipComponent
} from './components/builder-canvas/components/section-action-tooltip/section-action-tooltip.component';
import {
  SceletonLoadingComponent
} from './components/builder-canvas/components/sceleton-loading/sceleton-loading.component';
import {
  LoadingCircularSpinnerComponent
} from "../shared/components/loading-circular-spinner/loading-circular-spinner.component";
import {LoadingScreenComponent} from "../shared/components/loading-screen/loading-screen.component";
import {DsDropdownComponent} from "../shared/components/ds-dropdown/ds-dropdown.component";
import {
  ChooseBusinessTypeComponent
} from "./components/outline-generation/components/choose-website-type/choose-business-type.component";
import {
  CreateCompanyInfoComponent
} from "./components/outline-generation/components/create-company-info/create-company-info.component";
import {DbReplaceTextPipe} from "../shared/pipes/db-replace-text.pipe";
import {QuestionTourComponent} from "./components/question-tour/question-tour.component";
import {
  QuestionTourTooltipComponent
} from "./components/question-tour/components/question-tour-tooltip/question-tour-tooltip.component";
import {ArcadeVideoComponent} from "./components/arcade-video/arcade-video.component";
import {DbSafePipe} from "../shared/pipes/db-set-safe.pipe";
import {ZoomToFitComponent} from "./components/zoom-to-fit/zoom-to-fit.component";
import {
  SectionsLoadingComponent
} from './components/builder-canvas/components/page-constructor/components/sections-loading/sections-loading.component';
import {
  SectionOptionsComponent
} from './components/builder-canvas/components/page-constructor/components/section-options/section-options.component';
import {
  GenerationOptionsComponent
} from './components/builder-canvas/components/page-constructor/components/generation-options/generation-options.component';
import {
  PageTitleComponent
} from './components/builder-canvas/components/page-constructor/components/page-title/page-title.component';
import {
  SectionNotifsComponent
} from './components/builder-canvas/components/page-constructor/components/section-notifs/section-notifs.component';
import {MainSidebarEmptyComponent} from "../main-sidebar-empty/main-sidebar-empty.component";
import {StopPinchEventDirective} from "../shared/directives/stop-pinch-event/stop-pinch-event.directive";
import {SitemapMobileDialogComponent} from "./components/sitemap-mobile-dialog/sitemap-mobile-dialog.component";
import {LowerCaseSpecificWordsPipe} from "../shared/pipes/lowerCaseSpecificWords.pipe";
import {ClipboardModule} from "ngx-clipboard";
import {
  OutlineGenerationFinalizeComponent
} from "./components/outline-generation/components/outline-generation-finalize/outline-generation-finalize.component";
import {BuilderOutlineComponent} from "./components/builder-outline/builder-outline.component";
import {DraggableCanvasComponent} from "./components/draggable-canvas/draggable-canvas.component";
import { SecondaryPagesComponent } from './components/builder-canvas/components/secondary-pages/secondary-pages.component';
import { BuilderPageComponent } from './components/builder-canvas/components/builder-page/builder-page.component';
import { BuilderPageSectionComponent } from './components/builder-canvas/components/builder-page/components/builder-page-section/builder-page-section.component';
import { BuilderPageBodyComponent } from './components/builder-canvas/components/builder-page/components/builder-page-body/builder-page-body.component';
import { BuilderPageTitleComponent } from './components/builder-canvas/components/builder-page/components/builder-page-title/builder-page-title.component';
import { SectionFieldsComponent } from './components/builder-canvas/components/builder-page/components/builder-page-section/components/section-fields/section-fields.component';
import {ContenteditableValueAccessor} from "../shared/directives/content-editable/contenteditable.directive";
import { AddPageBtnComponent } from './components/builder-canvas/components/builder-page/components/add-page-btn/add-page-btn.component';
import { EditPageTooltipComponent } from './components/builder-canvas/components/builder-page/components/edit-page-tooltip/edit-page-tooltip.component';
import { ChangePageTypeTooltipComponent } from './components/builder-canvas/components/builder-page/components/builder-page-title/components/change-page-type-tooltip/change-page-type-tooltip.component';
import { EmptySecondaryPagesComponent } from './components/builder-canvas/components/secondary-pages/components/empty-secondary-pages/empty-secondary-pages.component';
import { AddSectionBtnComponent } from './components/builder-canvas/components/builder-page/components/builder-page-section/components/add-section-btn/add-section-btn.component';
import {NgClickOutsideDirective} from "ng-click-outside2";
// import {PanZoomComponent} from "ngx-panzoom";
import { PanZoomComponent } from './components/draggable-canvas/pan-zoom/pan-zoom.component';
import {
  OutlineGenerationSitemapComponent
} from "./components/outline-generation/components/outline-generation-sitemap/outline-generation-sitemap.component";
import {
  OutlineGenerationDesignComponent
} from "./components/outline-generation/components/outline-generation-design/outline-generation-design.component";
import {
  CanvasPageActionsComponent
} from "./components/builder-canvas/components/canvas-page-actions/canvas-page-actions.component";
import { SectionEditTooltipComponent } from './components/builder-canvas/components/canvas-page-actions/components/section-edit-tooltip/section-edit-tooltip.component';
import {
  SectionTemplatesComponent
} from "./components/builder-canvas/components/canvas-page-actions/components/section-templates/section-templates.component";
import {
  AddPageTooltipComponent
} from "./components/builder-canvas/components/canvas-page-actions/components/add-page-tooltip/add-page-tooltip.component";
import { CanvasTourTooltipComponent } from './components/builder-canvas/components/canvas-tour-tooltip/canvas-tour-tooltip.component';
import {SlideUpDirective} from "../shared/directives/slide-up/slide-up.directive";
import { SinglePageCreationStepComponent } from './single-page/components/single-page-creation-step/single-page-creation-step.component';
import {SinglePageBuilderComponent} from "./single-page/single-page-builder/single-page-builder.component";
import { SinglePageGenerationStepComponent } from './single-page/components/single-page-generation-step/single-page-generation-step.component';
import {
  MobileSignUpEmailComponent
} from "./components/outline-generation/components/mobile-sign-up-email/mobile-sign-up-email.component";
import {
  MobileSignUpComponent
} from "./components/outline-generation/components/mobile-sign-up/mobile-sign-up.component";
import {SuccessMobileDialogComponent} from "./components/success-mobile-dialog/success-mobile-dialog.component";
import {
  ChooseStoreTypeComponent
} from "./components/outline-generation/components/choose-store-type/choose-store-type.component";
import {
  CreateProductCategoriesComponent
} from "./components/outline-generation/components/create-product-categories/create-product-categories.component";
import { ProductListSectionPlaceholderComponent } from './components/builder-canvas/components/builder-page/components/product-list-section-placeholder/product-list-section-placeholder.component';
import { ProductPageTypeTooltipComponent } from './components/builder-canvas/components/builder-page/components/builder-page-title/components/product-page-type-tooltip/product-page-type-tooltip.component';
import {
  PrefilledCompanyInfoComponent
} from "./components/outline-generation/components/prefilled-company-info/prefilled-company-info.component";
import {LottieComponent} from "ngx-lottie";
import {
  WaveBackgroundComponent
} from "./components/outline-generation/components/wave-background/wave-background.component";
import {FadeInDirective} from "../shared/directives/fade-in/fade-in.directive";
import { SiteInfoSidebarComponent } from './components/outline-generation/components/outline-generation-sitemap/components/site-info-sidebar/site-info-sidebar.component';
import { SiteInfoEditComponent } from './components/outline-generation/components/outline-generation-sitemap/components/site-info-edit/site-info-edit.component';
import { SiteDescriptionEditComponent } from './components/outline-generation/components/outline-generation-sitemap/components/site-description-edit/site-description-edit.component';
import {
  PrefilledGenerationFinalizeComponent
} from "./components/outline-generation/components/prefilled-generation-finalize/prefilled-generation-finalize.component";
import { OutlineHeroGenerationComponent } from './components/outline-generation/components/outline-hero-generation/outline-hero-generation.component';
import { ATypeHeroSectionComponent } from './components/outline-generation/components/outline-hero-generation/components/a-type-hero-section/a-type-hero-section.component';
import { BTypeHeroSectionComponent } from './components/outline-generation/components/outline-hero-generation/components/b-type-hero-section/b-type-hero-section.component';
import { CapitalizeFirstPipe } from "../shared/pipes/db-capitilizeFirst.pipe";
import {
    FigmaLinkComponent
} from "./components/outline-generation/components/create-company-info/components/figma-link/figma-link.component";
import {
  VcImageUploadComponent
} from "./components/outline-generation/components/create-company-info/components/vc-image-upload/vc-image-upload.component";

@NgModule({
  declarations: [
    BuilderV2Component,
    BuilderHeaderComponent,
    BuilderCanvasComponent,
    SitemapMobileDialogComponent,
    PageConstructorComponent,
    ZoomControllerComponent,
    WebsiteCustomizerComponent,
    WebsiteCustomizerSwitcherComponent,
    WebsiteCustomizerSwitcherTooltipComponent,
    OutlineGenerationComponent,
    OutlineGenerationTourBannerComponent,
    PageSectionComponent,
    ZoomTooltipComponent,
    TooltipOptionComponent,
    SectionActionTooltipComponent,
    SceletonLoadingComponent,
    ChooseBusinessTypeComponent,
    CreateCompanyInfoComponent,
    OutlineGenerationFinalizeComponent,
    QuestionTourComponent,
    QuestionTourTooltipComponent,
    ArcadeVideoComponent,
    ZoomToFitComponent,
    SectionsLoadingComponent,
    SectionTemplatesComponent,
    SectionOptionsComponent,
    GenerationOptionsComponent,
    PageTitleComponent,
    SectionNotifsComponent,
    BuilderOutlineComponent,
    DraggableCanvasComponent,
    SecondaryPagesComponent,
    BuilderPageComponent,
    BuilderPageSectionComponent,
    BuilderPageBodyComponent,
    BuilderPageTitleComponent,
    SectionFieldsComponent,
    AddPageBtnComponent,
    EditPageTooltipComponent,
    AddPageTooltipComponent,
    ChangePageTypeTooltipComponent,
    EmptySecondaryPagesComponent,
    AddSectionBtnComponent,
    PanZoomComponent,
    AddSectionBtnComponent,
    OutlineGenerationSitemapComponent,
    OutlineGenerationDesignComponent,
    CanvasPageActionsComponent,
    SectionEditTooltipComponent,
    CanvasTourTooltipComponent,
    SinglePageCreationStepComponent,
    SinglePageBuilderComponent,
    SinglePageGenerationStepComponent,
    ChooseStoreTypeComponent,
    CreateProductCategoriesComponent,
    ProductListSectionPlaceholderComponent,
    ProductPageTypeTooltipComponent,
    PrefilledCompanyInfoComponent,
    SiteInfoSidebarComponent,
    SiteInfoEditComponent,
    SiteDescriptionEditComponent,
    PrefilledGenerationFinalizeComponent,
    OutlineHeroGenerationComponent,
    ATypeHeroSectionComponent,
    BTypeHeroSectionComponent
  ],
  imports: [
    CommonModule,
    BuilderV2RoutingModule,
    DsTooltipDirective,
    DragulaModule,
    DbTextPipe,
    NgxIntlTelInputModule,
    ReactiveFormsModule,
    NgOptimizedImage,
    ClickOutsideDirective,
    ClassChangeObserverDirective,
    LoadingCircularSpinnerComponent,
    LoadingScreenComponent,
    DsDropdownComponent,
    DbReplaceTextPipe,
    DbSafePipe,
    MainSidebarEmptyComponent,
    StopPinchEventDirective,
    LowerCaseSpecificWordsPipe,
    ClipboardModule,
    ContenteditableValueAccessor,
    NgClickOutsideDirective,
    SlideUpDirective,
    MobileSignUpComponent,
    MobileSignUpEmailComponent,
    SuccessMobileDialogComponent,
    FormsModule,
    LottieComponent,
    WaveBackgroundComponent,
    FadeInDirective,
    CapitalizeFirstPipe,
    FigmaLinkComponent,
    VcImageUploadComponent
  ],
  exports: [
    BuilderV2Component
  ]
})
export class BuilderV2Module {
}
